@if(component){
<div class="w-12 flex flex-justify-center">
    <div style="max-width: 1920px; overflow: hidden;"
         class="w-12">
        <div class="wrap">
            <!-- text box -->
            <text-box class="block p-t-20 p-t-15-s p-t-15-m "
                      [data]="component"
                      [textAlign]="'left'"></text-box>
            <!-- carousel -->
            <div class="pos-relative new-products-carousel-swiper-container">
                <div class="carousel-container">
                    <carousel class="default-swiper swiper-slide-per-view ugc-carousel default-pagination p-t-8 p-b-20 p-b-15-s p-b-15-m"
                              [slidesPerView]="'auto'"
                              [style.--pc-slides-ceil]="pcSlidesCeil"
                              [style.--pc-slides]="pcSlides"
                              [style.--pc-gutter]="pcGutter"
                              [style.--carousel-slides-per-view-round]="pcSlidesCeil"
                              [style.--carousel-space-between]="pcGutter"
                              [style.--carousel-slides-per-view]="pcSlides"
                              [navigation]="{
                                        nextEl: '.ugc-next-' + uid,
                                        prevEl: '.ugc-prev-' + uid
                                      }"
                              [scrollbar]="true"
                              [freeMode]="true"
                              imageViewRoot>
                        @for(slide of component.links; track slide){
                        <ng-template carouselSlide>
                            <href [link]="slide.tagLink"
                                  style="border-radius: 12px"
                                  class="overflow-hidden">
                                <df-image-wrapper>
                                    <img [ratio]="1"
                                         [dfImage]="slide.image">
                                </df-image-wrapper>
                            </href>

                            @if(slide.tagName && slide.tagLink) {
                            <href [link]="slide.tagLink">
                                <p class="s2 col-1 p-t-2"
                                   *iCms="'tagName' of slide; content: 'basicHtml'"></p>
                            </href>
                            }

                        </ng-template>
                        }
                    </carousel>

                    <!-- navigation buttons-->
                    @if(component.links.length > pcSlides){
                    <div class="pos-absolute w-12 z-5 ugc-carousel-buttons">
                        <button class="swiper-arrow-button pos-absolute inline-flex"
                                style="left: -20px"
                                [ngClass]="'ugc-prev-' + uid"
                                aria-label="Previous slide"
                                type="button">
                            <i class="icon-chevron-left col-w"
                               aria-hidden="true"></i>
                        </button>
                        <button class="swiper-arrow-button pos-absolute right-0 inline-flex"
                                style="right: -20px"
                                [ngClass]="'ugc-next-' + uid"
                                aria-label="Next slide"
                                type="button">
                            <i class="icon-chevron-right col-w"
                               aria-hidden="true"></i>
                        </button>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
}